import { apiGet, apiPost } from '../../api/api-configuration';
import { failureAction, getQueryStringHashToObject } from '../../app-actions';
import {
  API_COMPLETE_HOSTED_MIGRATION_ENDPOINT,
  API_GET_HOSTED_MIGRATION_CUSTOMER_DATA_ENDPOINT,
  API_INITIATE_HOSTED_MIGRATION_CUSTOMER_DATA_ENDPOINT,
  CUSTOMER_DETAILS_ABN_ACN,
  CUSTOMER_DETAILS_ADMIN_EMAIL_ADRESS,
  CUSTOMER_DETAILS_BILL_OR_ACCOUNT_NUMBER,
  CUSTOMER_DETAILS_COMPANY_TRADING_NAME,
  CUSTOMER_DETAILS_CONTACT_PHONE_NUMBER,
  CUSTOMER_DETAILS_FIRST_NAME,
  CUSTOMER_DETAILS_LAST_NAME,
  CUSTOMER_DETAILS_POST_CODE,
  CUSTOMER_DETAILS_STATE,
  CUSTOMER_DETAILS_STREET_ADDRESS,
  CUSTOMER_DETAILS_SUBURB,
  RADIO_BUTTON_CANCEL_ALL_ID,
  RADIO_BUTTON_CONFIRM_ID,
  API_POST_HOSTED_MIGRATION_CUSTOMER_DATA_ENDPOINT,
  API_INITIATE_SUBMIT_HOSTED_MIGRATION_CUSTOMER_DATA,
  API_COMPLETE_SUBMIT_HOSTED_MIGRATION_CUSTOMER_DATA,
} from '../../app-constants';
import {
  validateABNOrACN,
  validateAccountOrBillNumber,
  validateEmail,
  validatePhoneNumber,
  validatePostCode,
  validateText,
  validateTextAndNumbers,
} from '../ssm-homepage/ssm-homepage.actions';

export const successHostedMigration = (response) => {
  const { data } = response;
  return { type: API_COMPLETE_HOSTED_MIGRATION_ENDPOINT, data };
};

export const getUserId = () => {
  const parsedHash = getQueryStringHashToObject(window.location.hash);
  const {
    userId,
  } = parsedHash;
  return userId;
};

const getHostedMigration = data => (dispatch) => {
  const userId = getUserId();
  const endpoint = `${API_GET_HOSTED_MIGRATION_CUSTOMER_DATA_ENDPOINT}?userId=${userId}`;
  dispatch({ type: API_INITIATE_HOSTED_MIGRATION_CUSTOMER_DATA_ENDPOINT });
  apiGet(dispatch, endpoint, successHostedMigration, failureAction, data);
};

export const successActionSubmitSSMCustomerData = (response) => {
  const { data } = response;
  return { type: API_COMPLETE_SUBMIT_HOSTED_MIGRATION_CUSTOMER_DATA, data };
};

export const submitHMECustomerData = data => (dispatch) => {
  const endpoint = API_POST_HOSTED_MIGRATION_CUSTOMER_DATA_ENDPOINT;
  dispatch({ type: API_INITIATE_SUBMIT_HOSTED_MIGRATION_CUSTOMER_DATA });
  apiPost(dispatch, endpoint, successActionSubmitSSMCustomerData, failureAction, data);
};

export const validateCustomerDetailsFormFields = (id, value) => {
  if ((value && value.length > 0) || id === CUSTOMER_DETAILS_BILL_OR_ACCOUNT_NUMBER) {
    if (id === CUSTOMER_DETAILS_COMPANY_TRADING_NAME || id === CUSTOMER_DETAILS_FIRST_NAME
        || id === CUSTOMER_DETAILS_LAST_NAME || id === CUSTOMER_DETAILS_SUBURB) {
      return !validateText(value);
    } else if (id === CUSTOMER_DETAILS_ABN_ACN) {
      return !validateABNOrACN(value);
    } else if (id === CUSTOMER_DETAILS_POST_CODE) {
      return !validatePostCode(value);
    } else if (id === CUSTOMER_DETAILS_ADMIN_EMAIL_ADRESS) {
      return !validateEmail(value);
    } else if (id === CUSTOMER_DETAILS_CONTACT_PHONE_NUMBER) {
      return !validatePhoneNumber(value);
    } else if (id === CUSTOMER_DETAILS_STREET_ADDRESS) {
      return !validateTextAndNumbers(value);
    } else if (id === CUSTOMER_DETAILS_STATE) {
      return false;
    } else if (id === CUSTOMER_DETAILS_BILL_OR_ACCOUNT_NUMBER) {
      return !validateAccountOrBillNumber(value);
    }
  }
  return true;
};

export const enableSubmitButton = radioButtonOptions => !Object.values(radioButtonOptions).every(radioButton => !radioButton.checked);

export const validateCustomerFieldsOnSubmit = (customerDetailsFields) => {
  let newCustomerDetailsFieldsErrors = {};
  Object.keys(customerDetailsFields).forEach((customerDetailsFieldId) => {
    newCustomerDetailsFieldsErrors = { ...newCustomerDetailsFieldsErrors,
      [customerDetailsFieldId]: validateCustomerDetailsFormFields(customerDetailsFieldId,
        customerDetailsFields[customerDetailsFieldId]) };
  });
  return newCustomerDetailsFieldsErrors;
};

export const scrollElementIntoViewCenter = (elementId) => {
  document.getElementById(elementId).scrollIntoView({ block: 'center', inline: 'start' });
};

const escapeHTML = htmlText => (htmlText.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;'));

export const prepareHMESubmitData = (stateData, customerEmailAddresses, captchaToken) => {
  const { customerDetailsFields, confirmChangesRadioButtons, cancelServicesRadioButtons,
    isAdditionalLicencesOpen, additionalLicencesQuantity, additionalInfoComments,
    currentServicesRadioButtonStatus, allServicesCancelled } = stateData;
  const customerBillNumber = customerDetailsFields[CUSTOMER_DETAILS_BILL_OR_ACCOUNT_NUMBER].length > 0 ?
    customerDetailsFields[CUSTOMER_DETAILS_BILL_OR_ACCOUNT_NUMBER] : null;
  let confirmMigrateCancelOption = {};
  if (allServicesCancelled === false) {
    confirmMigrateCancelOption = confirmChangesRadioButtons
      .filter(confirmChangesRadioButton => confirmChangesRadioButton.id === RADIO_BUTTON_CONFIRM_ID)[0];
  } else {
    confirmMigrateCancelOption = cancelServicesRadioButtons
      .filter(cancelServicesRadioButton => cancelServicesRadioButton.id === RADIO_BUTTON_CANCEL_ALL_ID)[0];
  }

  const impactedEmailAddressesData = customerEmailAddresses.map((emailAddress) => {
    const optionSelected = currentServicesRadioButtonStatus
      .filter(currentService => currentService.emailAddress === emailAddress)[0].id.split('-')[2];
    return { emailAddress, migratedTo: optionSelected, migrate: optionSelected !== 'cancel' };
  });
  const hmeSubmitDataObject = {
    userId: getUserId(),
    impactedEmailAddresses: impactedEmailAddressesData,
    addMoreLicenses: allServicesCancelled === false ? isAdditionalLicencesOpen : null,
    webBasedExchangeOnlineLicenses: allServicesCancelled === false ? additionalLicencesQuantity.webBasedExchangeOnline : null,
    exchangeOnlineWithOutlookSupportLicenses: allServicesCancelled === false ?
      additionalLicencesQuantity.exchangeOnlineWithOutlookSupport : null,
    office365BusinessEssentialsLicenses: allServicesCancelled === false ?
      additionalLicencesQuantity.office365BusinessEssentials : null,
    office365BusinessPremiumLicenses: allServicesCancelled === false ? additionalLicencesQuantity.office365BusinessPremium : null,
    companyName: allServicesCancelled === false ? escapeHTML(customerDetailsFields[CUSTOMER_DETAILS_COMPANY_TRADING_NAME]) : null,
    abn: allServicesCancelled === false ? escapeHTML(customerDetailsFields[CUSTOMER_DETAILS_ABN_ACN]) : null,
    streetAddress: allServicesCancelled === false ? escapeHTML(customerDetailsFields[CUSTOMER_DETAILS_STREET_ADDRESS]) : null,
    suburb: allServicesCancelled === false ? escapeHTML(customerDetailsFields[CUSTOMER_DETAILS_SUBURB]) : null,
    state: allServicesCancelled === false ? escapeHTML(customerDetailsFields[CUSTOMER_DETAILS_STATE]) : null,
    postcode: allServicesCancelled === false ? escapeHTML(customerDetailsFields[CUSTOMER_DETAILS_POST_CODE]) : null,
    firstName: allServicesCancelled === false ? escapeHTML(customerDetailsFields[CUSTOMER_DETAILS_FIRST_NAME]) : null,
    lastName: allServicesCancelled === false ? escapeHTML(customerDetailsFields[CUSTOMER_DETAILS_LAST_NAME]) : null,
    billNumber: (allServicesCancelled === false && customerBillNumber !== null) ? escapeHTML(customerBillNumber) : null,
    adminEmailAddress: allServicesCancelled === false ? escapeHTML(customerDetailsFields[CUSTOMER_DETAILS_ADMIN_EMAIL_ADRESS]) : null,
    contactPhoneNumber: allServicesCancelled === false ? escapeHTML(customerDetailsFields[CUSTOMER_DETAILS_CONTACT_PHONE_NUMBER]) : null,
    additionalComments: additionalInfoComments.length > 0 ? escapeHTML(additionalInfoComments) : null,
    confirmMigrateCancel: confirmMigrateCancelOption.checked,
    gCaptchaToken: captchaToken,
  };
  return hmeSubmitDataObject;
};

export const populateCurrentServiceRadioStatusOnSelectAll = (customerEmailAddresses, selectAllRadioButton) => {
  const optionSelected = selectAllRadioButton.id.split('-')[2];
  const newCurrentServicesRadioButtonStatus = customerEmailAddresses.map(emailAddress => (
    { emailAddress, id: `id-${emailAddress}-${optionSelected}`, checked: true }
  ));

  return newCurrentServicesRadioButtonStatus;
};


export default getHostedMigration;

